import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  startDate: {
    id: '@lib.core.DateRangePicker.startDate',
    defaultMessage: 'Start Date',
  },
  endDate: {
    id: '@lib.core.DateRangePicker.endDate',
    defaultMessage: 'End Date',
  },
});
